module.exports = __webpack_public_path__ + "static/media/procedures.614266ad.svg";